import SignUpLogoModal from './sign_up_logo_modal';
export default SignUpLogoModal;
